/**
 * @fileoverview O aviso de limite do plano (31/10/2026, etapa 7 dos planos): o
 * toastError dispara este evento para o erro ERR_PLAN_LIMIT_* e só mostra o
 * toast quando ninguém o tratou (o PlanLimitPrompt, montado no layout, trata e
 * mostra o modal no lugar).
 */

export const PLAN_LIMIT_EVENT = "sttelar:plan-limit";

/** true: alguém tratou (o modal abriu); false: segue com o toast. */
export const announcePlanLimit = (detail) => !window.dispatchEvent(new CustomEvent(PLAN_LIMIT_EVENT, { cancelable: true, detail }));
